
import { NotificationFilter } from '@/entities/Notification/NotificationFilter';
import { Component, Prop, toNative, Vue } from 'vue-facing-decorator';
import NotificationFilterEditPane from './NotificationFilterEditPane.vue';
import { Root } from '@/main';
import Common from '@/helper/Common';
@Component({
  components: {
    NotificationFilterEditPane,
  },
})
class NotificationFilterListView extends Vue {
  @Prop() filtersData!: NotificationFilter[];
  private localFiltersData: NotificationFilter[] = [];
  private isMobileView = false;
  private mounted() {
    Common.ScrollToTop('notificationFilterListViewPane');
    if(!!this.filtersData) {
      this.localFiltersData = structuredClone(this.filtersData);
      this.localFiltersData.sort((item1, item2) => item1.FilterName.toLowerCase() > item2.FilterName.toLowerCase() ? 1 : -1);
    }
  }
  private ShowEmptyFilterScreen() {
    return this.localFiltersData === null || this.localFiltersData === undefined || this.localFiltersData.length === 0;
  }
  private CloseNotificationFilterListView() {
    Root.emit('show-filter-edit-pane', false);
  }
  private EditFilter(id: number) {
    Root.emit('selected-audience-filter-id', id);
  }
}
export default toNative(NotificationFilterListView);
